import { Link } from '@amzn/meridian';
import type { FC } from 'react';
import type { ProcessedError } from './ErrorAlert.types';
import { ExpandableErrorDetails } from './ExpandableErrorDetails';

type SingleErrorDisplayProps = {
  processedError: ProcessedError;
  isExpanded: boolean;
  onToggleExpanded: () => void;
};

/**
 * Displays a single error message with optional expandable additional details.
 * Handles the expand/collapse functionality for multi-line error messages.
 */
export const SingleErrorDisplay: FC<SingleErrorDisplayProps> = ({ processedError, isExpanded, onToggleExpanded }) => (
  <div>
    <div>{processedError.firstLine}</div>
    {processedError.hasMultipleLines && !isExpanded && <Link onClick={onToggleExpanded}>See more...</Link>}
    {isExpanded && (
      <>
        <ExpandableErrorDetails additionalLines={processedError.additionalLines} />
        <Link onClick={onToggleExpanded}>Show less</Link>
      </>
    )}
  </div>
);
